import { Shipment as BaseShipment } from '@pperform/pp-data-mappers';

class Shipment extends BaseShipment {}

export { Shipment };
